import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import LogoSection from './LogoSection';

const DesktopNavSection = ({ 
  onDrawerToggle,
  onLogoClick
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      flexShrink: 0, 
      px: 0 
    }}>
      <IconButton
        onClick={onDrawerToggle}
        sx={{ 
          color: '#666', 
          mr: 3,
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)'
          }
        }}
      >
        <MenuIcon />
      </IconButton>
      
      <LogoSection 
        onClick={onLogoClick}
        isMobile={false}
        centered={false}
      />
    </Box>
  );
};

export default DesktopNavSection; 